import { PostOrPage } from "@tryghost/content-api";

interface StaticGhostPageProps {
  page: PostOrPage;
  sidebar: PostOrPage;
}
export function StaticGhostPage({ page, sidebar }: StaticGhostPageProps) {
  return (
    <div className="container container_content container-padding-responsive flex gap-4">
      <div className="bg-white lg:bg-bg-gray p-4 lg:rounded-lg small-text lg:ml-0 w-full">
        {typeof page.html === "string" && (
          <div dangerouslySetInnerHTML={{ __html: page.html }} />
        )}
      </div>
      <div className="max-lg:hidden lg:bg-bg-gray lg:p-4 lg:rounded-lg min-w-[350px]">
        {typeof sidebar.html === "string" && (
          <div dangerouslySetInnerHTML={{ __html: sidebar.html }} />
        )}
      </div>
    </div>
  );
}
